<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <base-material-card
          color="primary"
          icon="mdi-garage"
          class="small-icon"
          :title="
            id
              ? $i18n.t('Edit Garage - ') + garage.name
              : $i18n.t('Create Garage')
          "
        >
          <v-form id="form">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    :label="$i18n.t('Name')"
                    dense
                    v-model="garage.name"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <z-country-select
                    class="purple-input"
                    v-model="garage.addr.country"
                  ></z-country-select>
                </v-col>

                <v-col cols="12" md="4">
                  <z-state-select
                    class="purple-input"
                    v-model="garage.addr.state"
                    :country="garage.addr.country"
                  ></z-state-select>
                </v-col>

                <v-col cols="12" md="4">
                  <z-city-select
                    class="purple-input"
                    v-model="garage.addr.city"
                    :state="garage.addr.state"
                    :country="garage.addr.country"
                  ></z-city-select>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                    :label="$i18n.t('addr')"
                    v-model="garage.addr.addressLine"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-checkbox
                    v-model="garage.hasSelfDrive"
                    :label="$i18n.t('Self Drive')"
                    dense
                  />
                </v-col>
                <v-col cols="12" md="12">
                  <v-row>
                    <gmap-map
                      :center="center"
                      :zoom="12"
                      style="width:100%;  height: 450px;"
                      ref="mapRef"
                    >
                      <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        @click="center = m.position"
                      ></gmap-marker>
                    </gmap-map>
                    <div style="width:100%;position: absolute;">
                      <gmap-autocomplete
                        @place_changed="setPlace"
                        :label="$i18n.t('Seach Location')"
                      ></gmap-autocomplete>
                    </div>
                    <div
                      style="top:-275px; width:50px;position:relative; margin:auto"
                    >
                      <v-icon style="font-size: 50px;" color="red"
                        >mdi-map-marker</v-icon
                      >
                    </div>
                  </v-row>
                </v-col>
              </v-row>
              <v-row style="padding: 0 20px">
                <v-btn small fab :to="'/settings/garage'">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  class="mr-0"
                  @click="save()"
                  :loading="loading"
                >
                  <h3>{{ $i18n.t("Save") }}</h3>
                </v-btn>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import init from "@/store/common/module/init";

@Component
export default class Tickets extends Vue {
  garage = {
    name: "",
    addr: { country: "", state: "", city: "", addrLine: "" },
  };

  id = null;
  center = { lat: 45.508, lng: -73.587 };
  markers = [];
  places = [];
  currentPlace = null;
  map = null;

  get loading() {
    return common.loading;
  }

  async save() {
    this.garage.addr.lat = this.map.getCenter().lat();
    this.garage.addr.lon = this.map.getCenter().lng();
    try {
      common.setLoading(true);
      const response = await doPost("/api/config/saveGarage", this.garage);
      if (!this.id) this.$router.push("/settings/garage/" + response._id);
      this.get(response._id);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      this.garage = await doGet("/api/garage/" + id + "/detail");
      this.id = this.garage._id;
      if (this.garage.addr.lat) {
        this.center = {
          lat: this.garage.addr.lat,
          lng: this.garage.addr.lon,
        };
      }
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
    await init.getUrlParameter("forCorp");
    if (init.urlParam) {
      this.garage.corp_id = init.urlParam;
    }
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;
    });
  }

  setPlace(place) {
    this.currentPlace = place;
    this.center = place.geometry.location;
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
